import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import env from '@tencent/vft-common/env';
import atom from '@tencent/vft-atom';
import * as jrQrcode from 'jr-qrcode';
import { setUrlParam } from '@tencent/vft-common/util';
import IconShare from '@tencent/vft-component/IconShare';
var shareList = window.setting.分享图切换配置;
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    shareInfo: {
      type: Object
    }
  },
  data: function data() {
    return {
      env: env,
      index: 0,
      key: Date.now(),
      base64: null
    };
  },
  watch: {
    value: function value(val) {
      if (val) {
        // this.loading.show()
        this.initShareInfo(Object.assign(this.params.shareCfg, {
          分享链接: this.params.shareUrl.replace(/qr\./, 'pg.')
        }), this.userService);
        this.hideAppClose();
        return;
      } // 还原分享


      this.initShareInfo(this.setting.默认分享, this.userService);
    }
  },
  components: {
    CloudSealCard: function CloudSealCard() {
      return import('@tencent/cloud-seal-card');
    },
    IconShare: IconShare
  },
  computed: {
    changeImgSrc: function changeImgSrc() {
      var _ref = this.shareInfo || {},
          action = _ref.action,
          type = _ref.type;

      return action === 'buy' && type === 'other' ? 'https://puui.qpic.cn/vupload/0/1595575875068_8cm47mgspmr/0' : 'https://puui.qpic.cn/vupload/0/1595576188271_cveib9sapts/0';
    },
    cardId: function cardId() {
      var _ref2 = this.shareInfo || {},
          action = _ref2.action,
          type = _ref2.type;

      return action === 'buy' && type === 'other' ? 'awrpNsnrjx' : 'OTZhMQ61Wm';
    },
    params: function params() {
      var _ref3 = this.shareInfo || {},
          action = _ref3.action,
          type = _ref3.type,
          price = _ref3.price,
          giftCount = _ref3.giftCount,
          oid = _ref3.oid;

      var _this$userService = this.userService,
          headurl = _this$userService.headurl,
          nick = _this$userService.nick,
          vuid = _this$userService.vuid;
      var vipIcon = this.vipService.vipIcon;

      var _ref4 = shareList[this.index] || shareList[0],
          背景图 = _ref4.背景图,
          分享文案 = _ref4.分享文案;

      var _this$setting = this.setting,
          门票炫耀分享 = _this$setting.门票炫耀分享,
          门票赠送分享 = _this$setting.门票赠送分享,
          门票领取分享 = _this$setting.门票领取分享,
          门票买自己分享 = _this$setting.门票买自己分享;
      var res = {
        shareCfg: 门票炫耀分享,
        nick: nick,
        headImg: headurl,
        level: vipIcon,
        pic: 背景图,
        qrUrl: setUrlParam('ptag', 'qr.xy', 'https://m.film.qq.com/vip-activity/ysf/index.html')
      }; // 购买多份分享给别人

      if (action === 'buy' && type === 'other') {
        res.price = price;
        res.giftMsg = 分享文案;
        res.giftCount = giftCount;
        res.qrUrl = setUrlParam('oid', oid, res.qrUrl);
        res.qrUrl = setUrlParam('uid', vuid, res.qrUrl);
        res.qrUrl = setUrlParam('ptag', 'qr.zs', res.qrUrl);
        res.shareCfg = 门票赠送分享;
      } else if (action === 'buy') {
        // 买给自己的
        res.shareCfg = 门票买自己分享;
        res.label = '已购买';
        res.qrUrl = setUrlParam('ptag', 'qr.self', res.qrUrl);
      } else if (action === 'receive' || action === 'share' && this.mySupportCount === 0) {
        res.shareCfg = 门票领取分享;
        res.label = '已获得';
        res.qrUrl = setUrlParam('ptag', 'qr.lq', res.qrUrl);
      } else if (action === 'share' && this.mySupportCount > 0) {
        res.supportCount = this.mySupportCount;
      }

      res.shareUrl = res.qrUrl;
      console.debug(res.qrUrl);
      res.qrUrl = this.getQrCode(res.qrUrl, this.cardId === 'OTZhMQ61Wm' ? '#8d427d' : '#9a6109');
      return res;
    }
  },
  methods: {
    hideAppClose: function hideAppClose() {
      if (env.isApp && this.page === 'share') {
        // 隐藏loading
        if (env.isAndroid) {
          try {
            atom.invoke('dismissLoading');
          } catch (e) {
            console.log(e);
          }
        } // 通知APP 页面已经展示OK 不需要展示透明webview的关闭按钮


        try {
          atom.invoke('hideBackButton', {
            hide: 1
          }); // 1表示隐藏
        } catch (e) {
          console.log(e);
        }
      }
    },
    getQrCode: function getQrCode(qrUrl) {
      var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#8d427d';
      var options = {
        padding: 10,
        // 二维码四边空白（默认为10px）
        width: 256,
        // 二维码图片宽度（默认为256px）
        height: 256,
        // 二维码图片高度（默认为256px）
        correctLevel: 1,
        // 二维码容错level（默认为高）
        reverse: false,
        // 反色二维码，二维码颜色为上层容器的背景颜色
        background: '#ffffff',
        // 二维码背景颜色（默认白色）
        foreground: color // 二维码颜色（默认黑色）

      };
      return jrQrcode.getQrBase64(qrUrl, options);
    },
    changeImg: function changeImg() {
      // this.loading.show()
      this.index = this.index + 1 > shareList.length - 1 ? 0 : this.index + 1;
      this.key = Date.now();
    },
    reset: function reset() {
      // this.loading.hide()
      this.base64 = null;
    },
    close: function close() {
      if (env.isApp && this.page === 'share') {
        // atom.invoke('closeH5')
        atom.close();
        return;
      }

      this.reset();
      this.$emit('input', false);
      this.$emit('close');
    },
    success: function success(img) {
      // this.loading.hide()
      this.base64 = img;
    }
  }
};